import { RootStore } from 'store';
import { type JsonDataItem } from 'types';

import env from 'env';

type BaseQueryOption = {
  type?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  body?: JsonDataItem;
};

const HTTP_STATUS_NO_CONTENT = 204;

export const baseQuery = async (url: string, options?: BaseQueryOption) => {
  const { token } = RootStore;
  const response = await fetch(`${env.API_SERVER}/${url}`, {
    method: `${options?.type ?? 'GET'}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(options?.body),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw { error: errorData, response: response };
  }

  if (response.status === HTTP_STATUS_NO_CONTENT) return;

  return await response.json();
};
